/**
 * JAVASCRIPT ROUTER
 * Definition of application routes and pages used by the router
 */
/*
Home
Menu 1
  Menu 11
  Menu 12
  Menu 13
Menu 3
Menu 2 (anchor)
  Menu 21
  Menu 22
  Menu 23
*/
import { writable } from 'svelte/store';
import ComponentHome from '../../pages/Home.svelte';
import ComponentLegalNotice from '../../pages/LegalNotice.svelte';
import ComponentConditionsOfUse from '../../pages/ConditionsOfUse.svelte';
import ComponentProjects from '../../pages/Projects.svelte';
export const idPageHome = "home";
export const idPageQui = "qui";
export const idPageQuoi = "quoi";
export const idPageComment = "comment";
export const idPageOu = "ou";
export const idPageLegal = "legal";
export const idPageCgv = "cgv";
export const idPageProjets = "projets";
export const nameFRPageHome = "ACCUEIL";
export const nameFRPageQui = "QUI ?";
export const nameFRPageQuoi = "QUOI ?";
export const nameFRPageComment = "COMMENT ?";
export const nameFRPageOu = "OU ?";
export const nameFRPageLegal = "Mentions légales";
export const nameFRPageCgv = "CGV";
export const nameFRPageProjets = "PROJETS";
export const nameENPageHome = "Home";
export const nameENPageQui = "WHO?";
export const nameENPageQuoi = "WHAT?";
export const nameENPageComment = "HOW?";
export const nameENPageOu = "WHERE?";
export const nameENPageLegal = "Legal notice";
export const nameENPageCgv = "Terms of sale";
export const nameENPageProjets = "PROJECTS";
export const storeFirstDisplayHome = writable(true);
export const routes = [];
export const pageHome = { id: idPageHome, nameFR: nameFRPageHome, nameEN: nameENPageHome, anchor: '', component: ComponentHome };
routes.push(pageHome);
export const pageQui = { id: idPageQui, nameFR: nameFRPageQui, nameEN: nameENPageQui, anchor: '#qui', component: ComponentHome };
routes.push(pageQui);
export const pageQuoi = { id: idPageQuoi, nameFR: nameFRPageQuoi, nameEN: nameENPageQuoi, anchor: '#quoi', component: ComponentHome };
routes.push(pageQuoi);
export const pageComment = { id: idPageComment, nameFR: nameFRPageComment, nameEN: nameENPageComment, anchor: '#comment', component: ComponentHome };
routes.push(pageComment);
export const pageOu = { id: idPageOu, nameFR: nameFRPageOu, nameEN: nameENPageOu, anchor: '#ou', component: ComponentHome };
routes.push(pageOu);
export const pageLegal = { id: idPageLegal, nameFR: nameFRPageLegal, nameEN: nameENPageLegal, anchor: '', component: ComponentLegalNotice };
routes.push(pageLegal);
export const pageCgv = { id: idPageCgv, nameFR: nameFRPageCgv, nameEN: nameENPageCgv, anchor: '', component: ComponentConditionsOfUse };
routes.push(pageCgv);
export const pageProjets = { id: idPageProjets, nameFR: nameFRPageProjets, nameEN: nameENPageProjets, anchor: '', component: ComponentProjects };
routes.push(pageProjets);
export const storeCurRoute = writable(idPageHome);
